import React from "react";
import styles from "./index.module.css";
import OutsideClickHandler from "react-outside-click-handler";
import { RiCloseLine } from "react-icons/ri";
import { FiFilter } from "react-icons/fi";

const FilterDropDown = ({
  selectedFilterItem,
  setSelectedFilterItem,
  showFilterDropdown,
  setShowFilterDropdown,
  filterDropdownItems,
  disabled = false,
}) => {
  return (
    <div className={styles.mainDiv}>
      <OutsideClickHandler
        onOutsideClick={() => {
          if (!disabled) setShowFilterDropdown(false);
        }}
      >
        <div className={styles.filterDiv}>
          <div
            onClick={() => {
              if (disabled) return;
              setShowFilterDropdown(!showFilterDropdown);
            }}
            className={disabled ? `${styles.filter} ${styles.filterDisabled}` : styles.filter}
            aria-disabled={disabled}
          >
            {selectedFilterItem ? (
              <>
                {selectedFilterItem}
                <RiCloseLine
                  onClick={() => {
                    setSelectedFilterItem(null);
                  }}
                  className={styles[`filterCloseIcon`]}
                />
              </>
            ) : (
              <>
                <FiFilter className={styles[`filter-icon`]} />
                Filters
              </>
            )}
          </div>
          <div
            className={
              showFilterDropdown
                ? styles.filterBottomDiv
                : styles.noFilterBottomDiv
            }
          >
            {filterDropdownItems.map((item) => (
              <>
                {item.name === selectedFilterItem ? (
                  <></>
                ) : (
                  <div
                    className={styles.filterBottomItem}
                    onClick={() => {
                      setSelectedFilterItem(item.name);
                      setShowFilterDropdown(false);
                    }}
                  >
                    {item.name}
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default FilterDropDown;
